import React, { useState } from "react";
import { Field } from "formik";
import {
  CsplTable as Table,
  FieldInput,
  FieldInputPercentage,
  AddPlans,
  SliderPanel,
  Link,
  WarningModal,
  FormControlSearch,
} from "../../../components";
import { get, isEmpty, uniqWith } from "lodash";
import { useDeepEffect } from "../../../abstracts";
import { Form, Button, InputGroup, Image } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/pro-light-svg-icons";

const columns = [
  {
    label: "Investment",
    className: "column-investment",
    columnName: "name",
  },
  {
    label: "Percentage",
    className: "column-percentage",
    columnName: "percentage",
  },
  {
    label: "Action",
    className: "column-action",
    columnName: "action",
  },
];

export const DifferentSourceElectionnSamePartcipantElection = (props) => {
  const {
    fields,
    isSave,
    isEdit,
    values,
    setFieldValue,
    handleChange,
    investmentList,
    sourcesList,
    setToggle,
    toggle,
    handleSubmit,
    additionalAutoEnrollmentData,
    deleteInvestment,
    planId,
    invetmentElectionError,
  } = props;

  const errorMsg = (invsum) =>
    invsum !== 100
      ? "PL821 : The total value of investment election should not exceed or subceed 100%"
      : "";
  const [isModalOpen, setModalOpen] = useState(false);
  const [sourceIndex, setSourceIndex] = useState();
  const [filteredResponse, setFilteredResponse] = useState({});
  const [addedInvestments, setAddedInvestments] = useState({});
  const [searchString, setSearchString] = useState("");
  const [saveInvestments, setSaveInvestments] = useState({});
  const [totalInvestments, setTotalInvestments] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const addInvestmentsToPlan = (investment) => {
    setAddedInvestments({
      ...addedInvestments,
      [sourceIndex]: [...(addedInvestments[sourceIndex] || []), investment],
    });
  };
  const onViewButtonClick = (index) => {
    setModalOpen(true);
    setSourceIndex(index);
  };

  const onSubmit = (savedInvestments) => {
    setSaveInvestments({ ...saveInvestments, [sourceIndex]: savedInvestments });
    setModalOpen(false);
  };
  const onCancel = () => {
    if (
      addedInvestments?.[sourceIndex]?.length !=
      saveInvestments?.[sourceIndex]?.length
    ) {
      setModalVisible(true);
    } else {
      setModalOpen(false);
    }
  };
  const modalOnCancel = () => {
    setAddedInvestments({
      ...addedInvestments,
      [sourceIndex]: saveInvestments[sourceIndex],
    });
    setModalOpen(false);
    setModalVisible(false);
  };

  useDeepEffect(() => {
    setSaveInvestments(values.initialSavedInvestments);
  }, [values.initialSavedInvestments]);

  useDeepEffect(() => {
    (sourceIndex || sourceIndex == 0) &&
      setFilteredResponse({
        ...filteredResponse,
        [sourceIndex]: investmentList.filter((team) => {
          return team.name.toLowerCase().includes(searchString.toLowerCase());
        }),
      });
  }, [searchString, investmentList, sourceIndex]);

  // useDeepEffect(() => {
  //   let defaults = !isEmpty(
  //     additionalAutoEnrollmentData.autoEnrollmentSouceInvestmentElections
  //   )
  //     ? [
  //         ...additionalAutoEnrollmentData?.autoEnrollmentSouceInvestmentElections,
  //       ]
  //     : [];
  //   setTotalInvestments(defaults);
  //   setSaveInvestments(defaults);
  //   setAddedInvestments(defaults);
  // }, [additionalAutoEnrollmentData]);

  useDeepEffect(() => {
    setTotalInvestments(saveInvestments);
  }, [saveInvestments]);
  const deletefunction = (name, index, ind) => {
    //var temp = totalInvestments.filter((e) => e.name !== name);
    var temp = saveInvestments[index].filter((e) => e.name !== name);
    setAddedInvestments({ ...addedInvestments, [index]: temp });
    setSaveInvestments({ ...saveInvestments, [index]: temp });
    // setTotalInvestments({ ...totalInvestments, [sourceIndex]: temp });
    values.additionalAutoEnrollmentSourceInvestmentElection[index] = get(
      values,
      `additionalAutoEnrollmentSourceInvestmentElection.${index}`
    ).filter((x) => x.name !== name);
  };
  const onDeleteClick = (name, index, ind) => {
    setToggle(!toggle);
    deletefunction(name, index, ind);
  };

  const Invsum = (index) => {
    const myArray = get(
      values.additionalAutoEnrollmentSourceInvestmentElection,
      index,
      []
    );
    var result = uniqWith(myArray, function (arrVal, othVal) {
      return arrVal.investmentId === othVal.investmentId;
    });
    let sum1 = 0;
    if (
      !isEmpty(
        get(values.additionalAutoEnrollmentSourceInvestmentElection, index)
      )
    )
      result.map((x) => {
        const tempInv = x?.investmentPercentage ? x?.investmentPercentage : 0;
        return (sum1 = sum1 + tempInv);
      });
    return sum1;
  };
  const AddName = (
    e,
    investmentName,
    investmentId,
    index,
    ind,
    sName,
    sourceId
  ) => {
    if (
      !isEmpty(
        get(
          values.additionalAutoEnrollmentSourceInvestmentElection,
          index,
          null
        )
      ) &&
      !isEmpty(
        get(
          values.additionalAutoEnrollmentSourceInvestmentElection,
          `${index}.${ind}`,
          null
        )
      )
    ) {
      //if(!isEmpty(values.autoEnrollmentSouceInvestmentElections[index].investmentElection[ind])){
      values.additionalAutoEnrollmentSourceInvestmentElection[index][
        ind
      ].investmentName = investmentName;
      values.additionalAutoEnrollmentSourceInvestmentElection[index][
        ind
      ].investmentId = investmentId;
      values.additionalAutoEnrollmentSourceInvestmentElection[index][
        ind
      ].sourceId = sourceId;
      values.additionalAutoEnrollmentSourceInvestmentElection[index][
        ind
      ].sourceName = sName;
      // }
    }
    handleChange(e);
  };
  const investmentListLength = (filteredResponse[sourceIndex] || []).length;
  // var ans;
  return (
    <div>
      <p className="mt-20 plan-heading-plan">List of sources</p>
      {(sourcesList || []).map((source, index) => {
        // ans = isEmpty(errorMsg(Invsum(index)))
        // console.log("uuu",isEmpty(errorMsg(Invsum(index))))
        const sliderPanel = (
          <SliderPanel isOpen={isModalOpen} size="35" showCancel={false}>
            <div className="d-flex justify-content-between align-baseline">
              <div>
                <p className="plan-heading-plan">Plan Investments</p>
                <p className="enrollment-sub-heading">
                  {investmentListLength}{" "}
                  {investmentListLength === 1
                    ? "Investment Available"
                    : "Investments Available"}
                </p>
              </div>
              <div>
                <Button variant="secondary" onClick={() => onCancel()}>
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  onClick={() => onSubmit(addedInvestments[sourceIndex])}
                  className="ml-4"
                >
                  Save
                </Button>
              </div>
            </div>
            <div className="search-bar-investment">
              <Form>
                <InputGroup>
                  <FormControlSearch
                    size="lg"
                    id="plan-search-box"
                    className="plan-search-box"
                    type="search"
                    autoComplete="off"
                    placeholder="Search Investment"
                    onChange={(e) => setSearchString(e.target.value)}
                  />
                  {/* <InputGroup.Append>
                    <InputGroup.Text className="search-bar-button">
                      <Image src="/assets/icons/svg/search.svg" width="14px" />
                    </InputGroup.Text>
                  </InputGroup.Append> */}
                </InputGroup>
              </Form>
            </div>
            <p className="enrollment-side-content">
              {investmentListLength}{" "}
              {investmentListLength === 1
                ? "Investment Available"
                : "Investments Available"}
            </p>
            <div className="scroll-body">
              {filteredResponse[sourceIndex] &&
                (filteredResponse[sourceIndex] || []).map((e, i) => (
                  <div className="d-flex justify-content-between">
                    <p>{e.name}</p>
                    {(addedInvestments[sourceIndex] || []).find(
                      (y) => y.name === e.name
                    ) ? (
                      // <Button
                      //   size="sm"
                      //   style={{ width: "75px", margin: "0px 0px 8px 0px" }}
                      //   variant="secondary"
                      //   disabled
                      //   classname="custom-added"
                      // >
                      //   Added
                      // </Button>
                      <div className="added-button-inside">
                        <div className="added-button-inner-text">Added</div>
                      </div>
                    ) : (
                      <>
                        {/* <Button
                          style={{ width: "75px", margin: "0px 0px 8px 0px" }}
                          variant="secondary"
                          onClick={() => addInvestmentsToPlan(e)}
                        >
                          Add
                        </Button> */}
                        <div
                          className="add-button-inside"
                          onClick={() => addInvestmentsToPlan(e)}
                        >
                          <div className="add-button-inner-text">Add</div>
                        </div>
                      </>
                    )}
                  </div>
                ))}
            </div>
          </SliderPanel>
        );
        if (
          !isEmpty(saveInvestments[index]) &&
          saveInvestments[index][0].name != null
          //!isEmpty(autoEnrollment.autoEnrollmentSouceInvestmentElections)
        ) {
          return (
            <div>
              <div className="mt-40 table-size">
                <div className="d-flex justify-content-between align-baseline">
                  <p className="mt-20 plan-heading-plan">{source.sourceName}</p>
                  <Button
                    variant="secondary"
                    disabled={isEdit && !isSave}
                    onClick={() => {
                      setModalOpen(true);
                      setSourceIndex(index);
                    }}
                  >
                    Add Investment
                  </Button>
                </div>
                <div>
                  <Table>
                    <Table.Thead>
                      <Table.Tr>
                        {columns.map((item, index) => {
                          return (
                            <Table.Th
                              key={index}
                              className={(item.className, "col-md-4")}
                            >
                              {item.label}
                            </Table.Th>
                          );
                        })}
                      </Table.Tr>
                    </Table.Thead>
                    <Table.Tbody>
                      {(saveInvestments[index] || []).map((investment, ind) => {
                        const fieldName = `additionalAutoEnrollmentSourceInvestmentElection[${index}][${ind}].investmentPercentage`;
                        return (
                          <Table.Tr key={ind}>
                            <Table.Td className="column-investment col-md-4">
                              {investment.name}
                            </Table.Td>
                            <Table.Td className="column-percentage">
                              <Form
                                autoComplete="off"
                                className="h-100 percentage-field"
                              >
                                <Field
                                  size="xs"
                                  isRequired
                                  name={fieldName}
                                  hasSuggestion
                                  shouldDisplaySuggestion
                                  component={FieldInputPercentage}
                                  type="number"
                                  value={get(values, fieldName)}
                                  onChange={(e) => {
                                    AddName(
                                      e,
                                      investment.name,
                                      investment.id,
                                      index,
                                      ind,
                                      source.sourceName,
                                      source.id
                                    );
                                  }}
                                  disabled={isEdit && !isSave}
                                  autoComplete="off"
                                  validate={(value) => {
                                    return value === null ||
                                      value === undefined ||
                                      value === ""
                                      ? "PL545 : Required"
                                      : value === 0
                                      ? "PL546 : Allocation percentage cannot be 0"
                                      : undefined;
                                  }}
                                />
                              </Form>
                            </Table.Td>
                            <Table.Td className="column-action col-md-4">
                              <Link>
                                <FontAwesomeIcon
                                  icon={faTrashAlt}
                                  color="red"
                                  onClick={() => {
                                    if (!(isEdit && !isSave))
                                      onDeleteClick(
                                        investment.name,
                                        index,
                                        ind
                                      );
                                  }}
                                />
                              </Link>
                            </Table.Td>
                          </Table.Tr>
                        );
                      })}
                    </Table.Tbody>
                    <div className="line-separator-total" />
                    <Table.Tbody>
                      <Table.Tr>
                        <Table.Td className="column-investment col-md-4">
                          Total
                        </Table.Td>
                        <Table.Td className="column-percentage col-md-4">
                          <Form
                            autoComplete="off"
                            className="h-100 percentage-field"
                          >
                            <Field
                              size="xs"
                              isRequired
                              name="totalBox"
                              hasSuggestion
                              shouldDisplaySuggestion
                              component={FieldInputPercentage}
                              type="number"
                              value={Invsum(index)}
                              autoComplete="off"
                              disabled
                              validate={(value) => {
                                return Invsum(index) != 100 ? " " : undefined;
                              }}
                            />
                            <p
                              style={{
                                display: "block",
                                color: "#ff5050",
                                fontSize: "0.75rem",
                                marginTop: "0rem",
                              }}
                            >
                              {errorMsg(Invsum(index))}
                            </p>
                          </Form>
                        </Table.Td>
                      </Table.Tr>
                    </Table.Tbody>
                  </Table>
                </div>
              </div>
              {sliderPanel}
            </div>
          );
        } else {
          return (
            <div>
              <div className="mt-40">
                <p className="mt-20 plan-heading-plan">{source.sourceName}</p>
                <AddPlans
                  content="No Investments added."
                  buttonLabel="Add Investment"
                  onPrimaryClick={() => onViewButtonClick(index)}
                  disabled={isEdit && !isSave}
                />
                <p
                  style={{
                    display: "block",
                    color: "#ff5050",
                    fontSize: "0.75rem",
                    marginTop: "0rem",
                  }}
                >
                  {get(
                    invetmentElectionError,
                    "investmentElectionDiffSourceSameParticipant",
                    ""
                  )}
                </p>
              </div>
              {sliderPanel}
            </div>
          );
        }
      })}
      <WarningModal show={modalVisible} onHide={() => setModalVisible(false)}>
        <div className="remove-text">
          <h4>Are you sure?</h4>
          <p>Your changes may be lost. Do you want to continue ?</p>
          <Button
            type="button"
            className="remove-btn mr-4"
            onClick={() => modalOnCancel()}
          >
            Yes
          </Button>
          <Button className="cancel-btn" onClick={() => setModalVisible(false)}>
            No
          </Button>
        </div>
      </WarningModal>
    </div>
  );
};

export default DifferentSourceElectionnSamePartcipantElection;
